module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-list', {
    staticClass: "pa-0",
    attrs: {
      "dense": "",
      "subheader": ""
    }
  }, [_c('v-subheader', {
    staticClass: "overline"
  }, [_vm._v("Forms")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), (_vm.request.loading) ? [_c('center', [_c('v-progress-circular', {
    staticClass: "ma-4",
    attrs: {
      "color": "amber",
      "indeterminate": "",
      "width": "2"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('small', [_vm._v("loading forms")])], 1)] : [_vm._l((_vm.forms), function(form) {
    return _c('v-list-tile', {
      key: form.id,
      on: {
        "click": function($event) {
          return _vm.$emit("selected", form)
        }
      }
    }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n          " + _vm._s(form.linked_form.title) + "\n        ")])], 1)], 1)
  }), _vm._v(" "), (_vm.forms && _vm.forms.length === 0) ? _c('v-list-tile', [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n          No linked forms found\n        ")])], 1)], 1) : _vm._e()]], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-af31338a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/lists/FormList.vue
// module id = 1511
// module chunks = 9